<body>
  <div class="snowflakes">
    <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i
    ><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i
    ><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i
    ><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i
    ><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i
    ><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i
    ><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i
    ><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i
    ><i></i><i></i><i></i>
  </div>
  <div>
    <div class="container-fluid first-section">
      <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-3 text-center">
          <div class="logo">
            <img src="{{ onPassiveBaseUrl }}onpassive(dec-19)/image/logo.png" alt="logo"/>
          </div>
        </div>
        <div class="col-lg-7 text-right">
          <div class="social-img">
            <a
              href="https://onpassive.com/blog"
              target="_blank"
              rel="noopener"
              title="ONPASSIVE Blog"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-19)/image/icon/blog1.png"
                class="blogicon" alt="blog1"
              />
            </a>
            <a
              href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Facebook"
            >
              <img
                src="{{ onPassiveBaseUrl }}onpassive(dec-19)/image/icon/fb.png" alt="Facebook"
              />
            </a>
            <a
              href="https://twitter.com/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Twitter"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-19)/image/icon/twitter.png" alt="Twitter"
              />
            </a>
            <a
              href="https://www.instagram.com/ONPASSIVE/"
              target="_blank"
              rel="noopener"
              title="Instagram"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-19)/image/icon/insta.png" alt="Instagram"
              />
            </a>
            <a
              href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Youtube"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-19)/image/icon/youtube.png" alt="YouTube"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
              target="_blank"
              rel="noopener"
              title="LinkedIn"
            >
              <img
                src="{{ onPassiveBaseUrl }}onpassive(dec-19)/image/icon/in.png" alt="LinkedIn"
              />
            </a>
          </div>
        </div>
        <div class="col-lg-1"></div>
      </div>
    </div>
  </div>
  <div class="second-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-5 mt-3">
          <div class="row">
            <div class="col-lg-11">
              <div class="content-img text-center">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(dec-19)/image/chritmas.png" alt="Chritmas"
                />
                <img
                  src="{{ onPassiveBaseUrl }}onpassive(dec-19)/image/bell.gif"
                  class="bell" alt="bell"
                />
              </div>
              <div class="content1 mt-5">
                <h2 class="content1_sub mt-3">LAUNCHING SOON</h2>
                <p class="content1_sub1 mt-3">
                  It is time for celebration and gathering. This holiday season,
                  gift yourself a business opportunity that lasts forever.
                  ONPASSIVE, with its bag full of spectacular business models,
                  is all set to spread divinity and cheer all around. ONPASSIVE
                  is going to bring a difference in the field of marketing by
                  aligning customer's needs with our specialisation. Launch your
                  Internet marketing business to a whole new level with the
                  right tools.
                </p>
              </div>
              <div class="btn new-btn mt-5">
                <a
                  href="/registration/user?reg={{ userId }}"
                  name="regform"
                  class="animated-button1"
                  target="_blank"
                  rel="noopener"
                >
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  BECOME A FOUNDER NOW</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mt-5 text-center">
          <!---------------------------------------------video-section------------------------------>
          <div class="mid-box">
            <div class="video-box">
              <video
                id="my-video"
                class="
                  video-js video-size
                  w-100
                  h-auto
                  my-video-dimensions
                  shadow
                "
                controls
                preload="auto"
                poster="{{ myLinksS3URL }}images/Image0231.png"
                data-setup="{}"
                autoplay="true"
                muted
              >
                <source
                  src="{{
                    myLinksS3URL
                  }}videos/Onpassive_launching_page_video2.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
            <div class="santa">
              <img
                src="{{ onPassiveBaseUrl }}onpassive(dec-19)/image/santa2.png" alt="santa2"
              />
            </div>
          </div>
          <!---------------------------------------------------------------------------------------->
  
        </div>
      </div>
    </div>
  </div>
  <!---------------------------Section End--------------------------------------------------------->
</body>
